import { render } from "./VNotification.vue?vue&type=template&id=0e3ff17e&scoped=true"
import script from "./VNotification.vue?vue&type=script&lang=js"
export * from "./VNotification.vue?vue&type=script&lang=js"

import "./VNotification.vue?vue&type=style&index=0&id=0e3ff17e&scoped=true&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3ff17e"]])

export default __exports__